export const filterOffersWithVariants = (offers) => offers
    .map((offer) => ({
    ...offer,
    variants: offer.variants.filter((variant) => variant.status !== 'UNAVAILABLE'),
}))
    .filter((offer) => offer.variants.length > 0);
